import React from "react";
import { cn } from "../../../lib/utils"; 

export const RadioGroup = ({ value, onValueChange, children, className }) => {
  return (
    <div className={cn("flex flex-col space-y-2", className)}>
      {React.Children.map(children, (child) =>
        React.isValidElement(child)
          ? React.cloneElement(child, { selectedValue: value, onValueChange })
          : child
      )}
    </div>
  );
};
